/** ±/value goal stepper used in the prediction card. Clamps 0–10. */
export function ScoreStepper({
  value,
  onChange,
  disabled,
  color = 'var(--amber)',
}: {
  value: number;
  onChange: (v: number) => void;
  disabled?: boolean;
  color?: string;
}) {
  const clamp = (v: number) => Math.max(0, Math.min(10, v));
  return (
    <div class="bc-stepper">
      <button
        type="button"
        class="bc-stepper__btn"
        disabled={disabled || value <= 0}
        aria-label="−"
        onClick={() => onChange(clamp(value - 1))}
      >
        −
      </button>
      <div class="bc-stepper__val" style={{ borderColor: color }}>
        {value}
      </div>
      <button
        type="button"
        class="bc-stepper__btn"
        disabled={disabled || value >= 10}
        aria-label="+"
        onClick={() => onChange(clamp(value + 1))}
      >
        +
      </button>
    </div>
  );
}
